import * as FluxUtils from 'flux/utils';

import { ReadOnly } from '../constants/Enums';
import { ActionConstants } from '../constants/ActionConstants';
import { DispatcherBaseAction, AppDispatcher } from '../dispatcher/AppDispatcher';
import { PriceObject, VariantObject } from '../Kompan';
import { PropertyMap, SimpleProperty } from './PropertyCompare';

interface KompanStoreState {
    price: PriceObject | null;
    variant: VariantObject | null;
    readOnly: ReadOnly;
    storedInitialProperties: PropertyMap;
    storedFinalProperties: PropertyMap;
}

class KompanStoreClass extends FluxUtils.ReduceStore<KompanStoreState, unknown> {
    public getInitialState(): KompanStoreState {
        return {
            price: null,
            variant: null,
            readOnly: ReadOnly.Disabled,
            storedInitialProperties: new Map<string, Map<string, Array<SimpleProperty>>>() as PropertyMap,
            storedFinalProperties: new Map<string, Map<string, Array<SimpleProperty>>>() as PropertyMap
        };
    }

    public reduce(state: KompanStoreState, action: DispatcherBaseAction): KompanStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.KOMPAN_SAVE_DATA:
                if (action.value == null || action.value.key == null) {
                    return state;
                }
                const payload: {[id: string]: unknown} = {};
                payload[action.value.key] = action.value.payload;
                return jQuery.extend({}, state, payload);
            default:
                return state;
        }

    }
}

export let KompanStore: KompanStoreClass = new KompanStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Kompan/KompanStore.ts